"use client";

import { Cookie } from "lucide-react";
import Link from "@/components/i18n/link";
import { useMessages } from "@/lib/i18n/client";
import { useConsentStore } from "@/lib/tracking/consent";
import messages from "./ConsentBanner.i18n";

// Aviso de consentimiento de la analítica detallada (Ley 21.719): las visitas
// se miden siempre; acciones y Clarity, solo si acepta. Aceptar y Rechazar
// tienen el mismo peso visual: rechazar no puede ser más difícil que aceptar.
// Se vuelve a abrir desde el footer ("Preferencias de cookies").
export function ConsentBanner() {
  const t = useMessages(messages);
  const visible = useConsentStore((s) => s.loaded && (s.choice === null || s.reopened));
  const choose = useConsentStore((s) => s.choose);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="consent-title"
      className="fixed inset-x-4 bottom-4 z-[1250] mx-auto max-w-xl rounded-xl border border-border bg-card p-4 shadow-lift"
    >
      <div className="flex items-start gap-3">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
        <div className="flex-1">
          <p id="consent-title" className="text-sm font-semibold">{t.title}</p>
          <p className="mt-1 text-sm text-muted-foreground">
            {t.body}{" "}
            <Link href="/privacidad" className="font-medium text-primary hover:underline">
              {t.more}
            </Link>
          </p>
        </div>
      </div>
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          onClick={() => choose("denied")}
          className="rounded-full border border-border px-4 py-1.5 text-sm font-semibold hover:cursor-pointer hover:bg-muted"
        >
          {t.reject}
        </button>
        <button
          type="button"
          onClick={() => choose("granted")}
          className="rounded-full border border-border px-4 py-1.5 text-sm font-semibold text-primary hover:cursor-pointer hover:bg-muted"
        >
          {t.accept}
        </button>
      </div>
    </div>
  );
}
